export default __webpack_public_path__ + "static/media/registro_muestras_updated.5eadd9b9.png";